import { ModalNames } from "@/components/modals/ModalsRenderer";
import { createContext } from "react";

export type ModalConfig = {
  modalName: ModalNames;
  onModalOpen?: () => void; // this function runs after the modal opens
  [key: string]: unknown;
};

export type IModalContext = {
  list: ModalConfig[];
  showModal: (props: ModalConfig) => void;
  closeModal: () => void;
  closeModalByName: (name: string) => void;
};

const ModalContext = createContext<IModalContext>({
  list: [],
  showModal: () => {},
  closeModal: () => {},
  closeModalByName: () => {},
});

export default ModalContext;
